import React from 'react';
import Lalamove from './LalamoveFeatures';
import Deliveree from './DelivereeFeatures';

const Feature = props => {
    if (props.courier === 'lalamove') {
        return <Lalamove service={props.service} onChange={props.onChange}/>
    } else if (props.courier === 'deliveree') {
        return <Deliveree service={props.service} onChange={props.onChange}/>
    }
    return null
}

export default Feature;